<template>
  <div class="ship_vio">
    <div class="vio_container">
      <div class="vio_title">
        基本信息
      </div>
      <div class="vio_num">
        船名: {{ ship.name_cn || ship.name_en }}
      </div>
      <div class="vio_num">
        MMSI: {{ ship.mmsi }}
      </div>
      <div class="vio_title">
        违规 | PSC检查
      </div>
      <div class="vio_num">
        违规次数: {{ credit.violation_num || 0 }}
      </div>
      <div class="vio_num">
        扣留次数: {{ detention || 0 }}
      </div>
      <div class="vio_title">
        <div class="vio_info_title">
          违规处罚记录
        </div>
        <div class="vio_info_num">({{credit.violation_num}})</div>
      </div>
      <div class="vio_log_one" v-for="(item,index) in vios">
        <div class="vio_log_date">
          {{ item.penalty_time_done }}
        </div>
        <div class="vio_log_type">
          {{ item.pred_type }} <div class="vio_log_btn" :data-index="index" @click="showVio">[查看详情]</div>
        </div>
      </div>
      <div class="vio_title">
        <div class="vio_info_title">
          PSC检查记录
        </div>
        <div class="vio_info_num">({{pscs.length}})</div>
      </div>
      <div class="vio_psc_one" v-for="(item,index) in pscs" :key="index">
        <div class="vio_psc_title">
          {{ item.ship.datestr }} {{ item.ship.type }}
        </div>
        <div class="vio_psc_dete" v-if="item.ship.detention === 'yes'" :data-index="index" @click="showDef">
          扣留
        </div>
        <div class="vio_psc_defi" :data-index="index" @click="showDef" v-if="item.deficiencies.length > 0">
          缺陷({{item.deficiencies.length || 0}})
        </div>
        <div class="vio_psc_defi vio_psc_defi_no" v-else>
          缺陷(0)
        </div>
        <div class="vio_log_btn" @click="showDef" :data-index="index" v-if="item.deficiencies.length > 0">[查看详情]</div>
      </div>
      <div class="vio_incident_close">
        <el-button type="info" size="small" @click="vioClose">关 闭 返 回</el-button>
      </div>
    </div>
    <el-dialog title="违规详情" :modal="false" width="100%" top="0" bootom="5vh" :visible.sync="vioVisible">
      <el-descriptions :column="1">
        <el-descriptions-item label="船名">{{vio.ileagal_subject_name || vio.ileagal_subject_name_en}}</el-descriptions-item>
        <el-descriptions-item label="违规日期">{{vio.penalty_time_done}}</el-descriptions-item>
        <el-descriptions-item label="违规类型">{{vio.pred_type}}</el-descriptions-item>
        <el-descriptions-item label="文书号">{{vio.doc_id}}</el-descriptions-item>
        <el-descriptions-item label="处罚海事局">{{vio.punish_agency}}</el-descriptions-item>
        <el-descriptions-item label="处罚原因">{{vio.reasons_of_punish}}</el-descriptions-item>
        <el-descriptions-item label="处罚内容">{{vio.penalty_content}}</el-descriptions-item>
        <el-descriptions-item label="违规条款">{{vio.penalty_clause}}</el-descriptions-item>
        <el-descriptions-item label="处罚理由">{{vio.penalty_accord}}</el-descriptions-item>
        <el-descriptions-item label="处罚对象" v-for="(item,index) in vio.info" :key="index">{{item.puni_object_name}} {{item.penalty_content}}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
    <el-dialog title="PSC检查记录详情" :modal="false" width="100%" top="0" bootom="5vh" :visible.sync="pscVisible">
      <el-descriptions :column="1">
        <el-descriptions-item label="船名">{{ship.name_cn || ship.name_en}}</el-descriptions-item>
        <el-descriptions-item label="Place" v-if="psc.ship">{{psc.ship.place}}</el-descriptions-item>
        <el-descriptions-item :label="item.code" :colon="false" v-for="(item,index) in psc.deficiencies" :key="index">Nature: {{item.nature}}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script>
  import { getShipPsc } from '../../api/api'
    export default {
      name: "info",
      props:{
          ship:{
            type:Object,
            value:{}
          },
          credit:{
            type:Object,
            value:{}
          }
      },
      data(){
        return {
          vios:[],
          pscs:[],
          vio:{},
          psc:{},
          vioVisible:false,
          pscVisible:false,
          detention:0
        }
      },
      mounted(){
        this.vios = this.credit.violation;
        this.getPsc();
      },
      methods: {
        showVio(e){
          this.vio = this.vios[parseInt(e.target.dataset.index)];
          this.vioVisible = true;
        },
        showDef(e){
          this.psc = this.pscs[parseInt(e.target.dataset.index)];
          this.pscVisible = true;
        },
        getPsc(){
          getShipPsc(this.ship.imo,this.ship.mmsi).then(res => {
            if(res && res.status === 0){
              this.pscs = res.inspections;
              for(let p in this.pscs){
                if(this.pscs[p].ship.detention === 'yes'){
                  this.detention++;
                }
              }
            }
          });
        },
        vioClose(){
          this.$emit('shipVioClose',null);
        }
      }
    }
</script>

<style scoped>
  .vio_container {
    width:90%;
    margin:.5rem auto;
  }

  .vio_title {
    font-weight: bold;
    height:2rem;
    line-height: 2rem;
    text-indent: .5rem;
    width:100%;
    background-color: rgba(100,100,100,0.1)
  }

  .vio_num {
    text-indent: .8rem;
    height:2rem;
    line-height: 2rem;
    font-size:.8rem;
    font-weight: bold;
    color:grey;
    border-bottom:1px solid rgba(100,100,100,0.1)
  }

  .vio_info_title {
    float:left;
  }

  .vio_info_num {
    font-size:.8rem;
    color:red;
    float:left;
  }

  .vio_incident_one {
    font-size:.8rem;
    height:2rem;
    line-height:2rem;
    margin-bottom:2rem;
    text-indent: .8rem;
  }

  .vio_incident_close {
    height:3rem;
    line-height:3rem;
    margin-bottom:2rem;
    text-align:center;
  }

  .vio_psc_one {
    font-size:.8rem;
    height:4rem;
    border-bottom:1px solid rgba(100,100,100,0.1)
  }

  .vio_psc_title {
    float:left;
    width:100%;
    height: 2rem;
    line-height:2rem;
    text-indent: .8rem;
  }

  .vio_psc_defi {
    float:left;
    width:3.6rem;
    height:1.4rem;
    font-size:.7rem;
    font-weight: bold;
    line-height: 1.4rem;
    text-align: center;
    color:rgb(250, 50, 50);
    border:1px solid rgba(233, 104, 104, 0.9);
    background-color:rgba(233, 104, 104, 0.1);
    border-radius: .3rem;
    margin-left:.8rem;
  }

  .vio_psc_defi_no {
    border:1px solid rgb(180,180,180);
    background-color:rgba(200,200,200,0.2);
    color:rgb(150,150,150);
  }

  .vio_psc_dete {
    float:left;
    width:3rem;
    height:1.4rem;
    font-size:.7rem;
    line-height: 1.4rem;
    text-align: center;
    color:white;
    border:1px solid rgb(6, 112, 185);
    background-color:rgb(6, 112, 185);
    border-radius: .8rem;
    margin-left:.8rem;
  }

  .vio_log_one {
    font-size:.8rem;
    height:2rem;
    line-height: 2rem;
    border-bottom:1px solid rgba(100,100,100,0.1);
  }

  .vio_log_date {
    width:35%;
    float:left;
    text-indent: .8rem;
  }

  .vio_log_type {
    width:65%;
    float:left;
    color: red;
  }

  .vio_log_btn {
    width:4rem;
    color:red;
    float:right;
  }
</style>



// WEBPACK FOOTER //
// src/components/ship/vio.vue